module.exports = __webpack_public_path__ + "media/packs/images/flags/GE-dc9fb2da9a12e3a1b9501671dabf9801.svg";